export default {
  url: process.env.NODE_ENV === "development" ? "" : process.env.VUE_APP_SERVER_URL
};
